// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetIntegrationCallOverviewRequestModel from '../../model/get-integration-call-overview-request-model';
import GetIntegrationCallOverviewRequestDTO from '../dto/get-integration-call-overview-request-dto';
import dtoSchema from '../schemas/get-integration-call-overview-request-schema';

export default abstract class GetIntegrationCallOverviewRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetIntegrationCallOverviewRequestDTO>) {
    super();
    if (data) {
      this.from = data.from;
      this.to = data.to;
    }
  }
  /**
  * @type {date-time}
  */
  from?: string;
  /**
  * @type {date-time}
  */
  to?: string;

  static toModel(dto: DeepPartial<GetIntegrationCallOverviewRequestDTO>): GetIntegrationCallOverviewRequestModel;
  static toModel(dto: DeepPartial<GetIntegrationCallOverviewRequestDTO> | undefined | null): GetIntegrationCallOverviewRequestModel | undefined;
  static toModel(dto: DeepPartial<GetIntegrationCallOverviewRequestDTO> | undefined | null): GetIntegrationCallOverviewRequestModel | undefined {
    return dto ? new GetIntegrationCallOverviewRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetIntegrationCallOverviewRequestModel> | GetIntegrationCallOverviewRequestModel): GetIntegrationCallOverviewRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      from: unwrapped.from,
      to: unwrapped.to,
    } as GetIntegrationCallOverviewRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetIntegrationCallOverviewRequestModel, can not map to GetIntegrationCallOverviewRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
